"use strict";
/* Copyright (c) 2022 Xperi. All Rights Reserved. */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationsLogger = void 0;
var Logger_1 = require("./Logger");
var OperationsLogger = /** @class */ (function (_super) {
    __extends(OperationsLogger, _super);
    function OperationsLogger() {
        var _this = _super.call(this) || this;
        _this.queueName = '';
        _this.queue = false;
        /**
         * use to log the events
         * @param params params to log
         */
        _this.noConsole = false;
        return _this;
    }
    OperationsLogger.prototype.setQueueName = function (queueName) {
        this.queueName = queueName;
        this.queue = true;
    };
    OperationsLogger.prototype.log = function (event) {
        var _this = this;
        this.logDiagnosticsEvent(OperationsLogger.TAG, event);
        this.transport
            .send(event)
            .then(function () {
            if (_this.queue)
                postMessage({ type: _this.queueName, message: 'success' }, '*');
        })
            .catch(function (status) {
            if (!status && _this.queue)
                postMessage({ type: _this.queueName, message: 'networkDown' }, '*');
        });
    };
    OperationsLogger.prototype.logDiagnosticsEvent = function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        if (!this.noConsole)
            console.log.apply(console, params);
    };
    OperationsLogger.TAG = 'OperationsLogger';
    return OperationsLogger;
}(Logger_1.Logger));
exports.OperationsLogger = OperationsLogger;
